"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  configuredCarInputToPrString: () => configuredCarInputToPrString,
  mbvIdToConfiguredCarIdentifier: () => mbvIdToConfiguredCarIdentifier,
  prStringToConfiguredCarInput: () => prStringToConfiguredCarInput
});
module.exports = __toCommonJS(index_exports);

// src/pr-string/pr-string-to-configured-car-input.ts
var REGEX_MBV = /^\d+\\\d{4}\|/i;
var REGEX_NEMO = /^\w+_\d{4}\|/i;
var REGEX_NEMO_MODEL_CODE = /^(\w{6})(\d)(\w*)?_(\d{4})*/i;
var REGEX_CASA = /^\d{5}\|\d+\\\d{4}\|/i;
var REGEX_CARINFO = /^(?<code>\w+?)\\(?<version>\d)\\?(?<extensionsAll>\w{7}(?:\\\w{7})*)?-\d{5}\\(?<year>\d{4})\|(?<restAll>.*)$/i;
var REGEX_CARINFO_EXTENSION = /^\w*(?<extension>\w{3})$/i;
var REGEX_CARINFO_PART = /^(?<key>\w{3,4})\s*(?<value>\w+?)$/i;
function mbvIdToConfiguredCarIdentifier(mbvIdString, country, language, brand = "A", pr7only = false) {
  if (pr7only) {
    return transformMBVIDPr7Only(mbvIdString, country, language, brand, false);
  }
  return transformMBVID(mbvIdString, country, language, brand, false);
}
function getTransformerSwitchFct(prstring, usePr7Only = false) {
  if (REGEX_MBV.test(prstring)) {
    if (usePr7Only) {
      return transformMBVIDPr7Only;
    }
    return transformMBVID;
  }
  if (REGEX_NEMO.test(prstring)) {
    if (usePr7Only) {
      return transformPr7OnlyNEMO;
    }
    return transformNEMO;
  }
  if (REGEX_CASA.test(prstring)) {
    if (usePr7Only) {
      return transformPr7OnlyCASA;
    }
    return transformCASA;
  }
  if (REGEX_CARINFO.test(prstring)) {
    if (usePr7Only) {
      return transformPr7OnlyCARINFO;
    }
    return transformCARINFO;
  }
  throw new Error(`No valid prstring. [${prstring}]`);
}
function prStringToConfiguredCarInput(prstring, country, language, brand = "A", pr7only = false) {
  const transformFct = getTransformerSwitchFct(prstring, pr7only);
  return transformFct(prstring, country, language, brand);
}
function transformMBVID(prstring, country, language, brand, createInput = true) {
  const prObject = parsePRString(prstring);
  return {
    brand,
    country,
    language,
    salesGroup: prObject.modelCode,
    model: {
      year: parseInt(prObject.modelYear, 10),
      version: parseInt(prObject.version, 10),
      code: prObject.code,
      extensions: prObject.extensions ? prObject.engine.split("\\").slice(2).map((p) => {
        return p.substring(4);
      }) : [],
      ...!createInput ? {
        extensionsPR7: prObject.extensions ? prObject.engine.split("\\").slice(2) : []
      } : {}
    },
    exteriorColor: prObject.exteriorColor.substring(4),
    interiorColor: prObject.interiorColor.substring(8),
    equipmentOptions: prObject.equipmentOptions.length > 0 ? prObject.equipmentOptions : null
  };
}
function parsePRString(prstring) {
  const parts = prstring.split("|");
  const [model, engine, exteriorColor, interiorColor, ...equipmentOptions] = parts;
  const [modelCode, modelYear] = model.split("\\");
  const [code, version, extensions] = engine.split("\\");
  return {
    modelCode,
    modelYear,
    exteriorColor,
    interiorColor,
    equipmentOptions,
    code,
    version,
    extensions,
    engine
  };
}
function transformMBVIDPr7Only(prstring, country, language, brand, createInput = true) {
  const prObject = parsePRString(prstring);
  const extensionsArray = prObject.extensions ? prObject.engine.split("\\").slice(2) : [];
  return {
    brand,
    country,
    language,
    salesGroup: prObject.modelCode,
    model: {
      year: parseInt(prObject.modelYear, 10),
      version: parseInt(prObject.version, 10),
      code: prObject.code,
      extensions: extensionsArray,
      ...!createInput ? { extensionsPR7: extensionsArray } : {}
    },
    exteriorColor: prObject.exteriorColor.substring(4),
    interiorColor: prObject.interiorColor.substring(8),
    equipmentOptions: prObject.equipmentOptions.length > 0 ? prObject.equipmentOptions : null
  };
}
function transformCASA(prstring, country, language, brand) {
  const prstringpart = prstring.substring(prstring.indexOf("|") + 1);
  return transformMBVID(prstringpart, country, language, brand);
}
function transformPr7OnlyCASA(prstring, country, language, brand) {
  const prstringpart = prstring.substring(prstring.indexOf("|") + 1);
  return transformMBVIDPr7Only(prstringpart, country, language, brand);
}
function transformNEMO(prstring, country, language, brand) {
  const parts = prstring.split("|");
  if (parts.length < 3) {
    throw new Error(
      `invalid nemo pr string. need at least model, exteriorColor and interiorColor [${prstring}]`
    );
  }
  const [model, exteriorColor, interiorColor, ...options] = parts;
  const [match, code, version, extensions, year] = model.match(REGEX_NEMO_MODEL_CODE) || new Array(5);
  if (!match) {
    throw new Error(`could not match model from pr string [${prstring}]`);
  }
  if (!exteriorColor || exteriorColor.length !== 4) {
    throw new Error(
      `could not match exteriorColor from pr string [${prstring}]`
    );
  }
  if (!interiorColor || interiorColor.length !== 2) {
    throw new Error(
      `could not match interiorColor from pr string [${prstring}]`
    );
  }
  return {
    brand,
    country,
    language,
    model: {
      year: parseInt(year, 10),
      version: parseInt(version, 10),
      code,
      extensions: extensions == null ? void 0 : extensions.match(/.{1,3}/g)
    },
    exteriorColor,
    interiorColor,
    equipmentOptions: options.length > 0 ? options : void 0
  };
}
function transformPr7OnlyNEMO(prstring, country, language, brand) {
  const parts = prstring.split("|");
  if (parts.length < 3) {
    throw new Error(
      `invalid nemo pr string. need at least model, exteriorColor and interiorColor [${prstring}]`
    );
  }
  const [model, exteriorColor, interiorColor, ...options] = parts;
  const [match, code, version, extensions, year] = model.match(REGEX_NEMO_MODEL_CODE) || new Array(5);
  if (!match) {
    throw new Error(`could not match model from pr string [${prstring}]`);
  }
  if (!exteriorColor || exteriorColor.length !== 4) {
    throw new Error(
      `could not match exteriorColor from pr string [${prstring}]`
    );
  }
  if (!interiorColor || interiorColor.length !== 2) {
    throw new Error(
      `could not match interiorColor from pr string [${prstring}]`
    );
  }
  return {
    brand,
    country,
    language,
    model: {
      year: parseInt(year, 10),
      version: parseInt(version, 10),
      code,
      extensions: extensions == null ? void 0 : extensions.match(/.{1,7}/g)
    },
    exteriorColor,
    interiorColor,
    equipmentOptions: options.length > 0 ? options : void 0
  };
}
function parseCARINFO(prstring) {
  const result = prstring.match(REGEX_CARINFO);
  const { code, version, extensionsAll, year, restAll } = (result == null ? void 0 : result.groups) || {};
  const rest = (restAll == null ? void 0 : restAll.split("|")) || [];
  const parts = Object.fromEntries(
    rest.map((part) => {
      var _a;
      return (_a = part.match(REGEX_CARINFO_PART)) == null ? void 0 : _a.groups;
    }).filter(
      (partMatch) => Boolean(partMatch)
    ).map(({ key, value }) => [key, value])
  );
  const { F56: interiorColor, F14: exteriorColor, ...partsRest } = parts;
  const options = Object.keys(partsRest).map(
    (key) => `${key}${partsRest[key]}`
  );
  if (!exteriorColor || exteriorColor.length !== 4) {
    throw new Error(
      `could not match exteriorColor from pr string [${prstring}]`
    );
  }
  if (!interiorColor || interiorColor.length !== 2) {
    throw new Error(
      `could not match interiorColor from pr string [${prstring}]`
    );
  }
  return {
    code,
    version,
    extensionsAll,
    year,
    options,
    exteriorColor,
    interiorColor
  };
}
function transformCARINFO(prstring, country, language, brand) {
  var _a;
  const prObject = parseCARINFO(prstring);
  const extensions = (((_a = prObject.extensionsAll) == null ? void 0 : _a.split("\\")) || []).map(
    (extension) => {
      var _a2, _b;
      return (_b = (_a2 = extension.match(REGEX_CARINFO_EXTENSION)) == null ? void 0 : _a2.groups) == null ? void 0 : _b.extension;
    }
  ).filter(
    (extensionMatch) => Boolean(extensionMatch)
  );
  return {
    brand,
    country,
    language,
    model: {
      year: Number.parseInt(prObject.year, 10),
      version: Number.parseInt(prObject.version, 10),
      code: prObject.code,
      extensions: extensions.length ? extensions : void 0
    },
    exteriorColor: prObject.exteriorColor,
    interiorColor: prObject.interiorColor,
    equipmentOptions: prObject.options.length ? prObject.options : void 0
  };
}
function transformPr7OnlyCARINFO(prstring, country, language, brand) {
  var _a;
  const prObject = parseCARINFO(prstring);
  const extensions = ((_a = prObject.extensionsAll) == null ? void 0 : _a.split("\\")) || [];
  return {
    brand,
    country,
    language,
    model: {
      year: Number.parseInt(prObject.year, 10),
      version: Number.parseInt(prObject.version, 10),
      code: prObject.code,
      extensions: extensions.length ? extensions : void 0
    },
    exteriorColor: prObject.exteriorColor,
    interiorColor: prObject.interiorColor,
    equipmentOptions: prObject.options.length ? prObject.options : void 0
  };
}

// src/pr-string/configured-car-input-to-pr-string.ts
function configuredCarInputToPrString(configuredCarInput) {
  const {
    equipmentOptions,
    exteriorColor,
    interiorColor,
    model: { code, version, year, extensions }
  } = configuredCarInput;
  const prString = `${code}${version}${Array.isArray(extensions) ? extensions.join("") : ""}_${year}|${exteriorColor}|${interiorColor}`;
  if (!Array.isArray(equipmentOptions) || equipmentOptions.length === 0) {
    return prString;
  }
  return prString.concat("|", equipmentOptions.join("|"));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  configuredCarInputToPrString,
  mbvIdToConfiguredCarIdentifier,
  prStringToConfiguredCarInput
});
//# sourceMappingURL=index.js.map
